import React from 'react'
import styled from 'styled-components'

import coinsGif from './assets/coin.gif'
import walletImg from './assets/wallet-purse.svg'

// Figma 4424:133886 — wallet (4424:133887 wired-flat-421-wallet-purse) behind
// coins GIF (wired-flat-298-coins#hover-jump). Multi-color illustration — keep
// brand colors across light/dark themes.
// Natural size is 168×156 (full-page exhaustion state); toasts pass a `scale`
// to shrink it to the Figma toast size (4584:149296 — IC-49735).
const BASE_WIDTH = 168
const BASE_HEIGHT = 156

// Reserve the scaled layout box, then scale the natural-size art into it so the
// artwork stays pixel-accurate at any scale.
const Scaler = styled.div`
  width: ${({ $scale }) => BASE_WIDTH * $scale}px;
  height: ${({ $scale }) => BASE_HEIGHT * $scale}px;
  flex-shrink: 0;
  pointer-events: none;
  user-select: none;
`

const Frame = styled.div`
  position: relative;
  width: ${BASE_WIDTH}px;
  height: ${BASE_HEIGHT}px;
  transform: scale(${({ $scale }) => $scale});
  transform-origin: top left;
`

const Wallet = styled.img`
  position: absolute;
  left: 44px;
  top: 0;
  width: 124px;
  height: 124px;
  display: block;
`

const Coins = styled.img`
  position: absolute;
  left: 0;
  top: 33px;
  width: 123px;
  height: 123px;
  display: block;
  object-fit: contain;
`

const WalletCoinsIllustration = ({ scale = 1 }) => (
  <Scaler $scale={scale} aria-hidden>
    <Frame $scale={scale}>
      <Wallet src={walletImg} alt="" />
      <Coins src={coinsGif} alt="" />
    </Frame>
  </Scaler>
)

export default WalletCoinsIllustration
